import { render } from "./appointments-list.vue?vue&type=template&id=0b260b41"
import script from "./appointments-list.vue?vue&type=script&lang=js"
export * from "./appointments-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__